import { Link, useLocation } from "react-router-dom";
import { Compass, ChevronLeft } from "lucide-react";

import styles from "./ForbiddenPage.module.css";

export function NotFoundPage() {
  const location = useLocation();
  return (
    <div className={styles.page}>
      <div className={styles.hero}>
        <div className={`${styles.icon} ${styles.iconInfo}`} aria-hidden="true">
          <Compass size={40} strokeWidth={2} />
        </div>
        <div className={styles.code}>Error 404 · admin_not_found</div>
        <h1 className={styles.title}>We couldn&apos;t find that page</h1>
        <p className={styles.desc}>
          This project or page may have been removed, renamed, or never existed.
          The link might also be incorrect.
        </p>

        <div className={styles.cta}>
          <Link to="/projects" className={`${styles.btn} ${styles.btnSecondary}`}>
            <ChevronLeft size={13} aria-hidden="true" />
            Back to projects
          </Link>
          <Link to="/projects" className={`${styles.btn} ${styles.btnPrimary}`}>
            Go to my projects
          </Link>
        </div>

        <div className={styles.helper}>
          Tried URL: <code>{location.pathname}</code>
        </div>
      </div>
    </div>
  );
}
